import { fromSeoUrl } from 'helpers/HelperFunctions';
import {
  EXPERIENCE_LEVEL_OPTIONS,
  isExperienceGroupChecked,
} from './experienceLevelOptions';

/**
 * Labels for the applied filters other than roles, for the line under the
 * results heading. These sit below the roles in the panel, so a saved
 * filter there is easy to miss.
 *
 * @param {object} filter ProjectsBase filter state
 * @returns {string[]}
 */
export default function getFilterSummary(filter) {
  if (!filter) return [];

  const labels = [];

  if (filter.searchTerm) {
    labels.push(`“${filter.searchTerm}”`);
  }

  if (filter.locationText) {
    // Route params are slugs ("new-york"); picked places are already readable.
    const readable = (value) =>
      value === value.toLowerCase() ? fromSeoUrl(value) : value;
    const place = [filter.city, filter.country]
      .filter(Boolean)
      .map(readable)
      .join(', ');
    labels.push(place || fromSeoUrl(filter.locationText));
  }

  if (filter.remote) {
    labels.push('Remote');
  }

  const experience = EXPERIENCE_LEVEL_OPTIONS.filter((option) =>
    isExperienceGroupChecked(filter.experienceLevels, option)
  ).map((option) => option.label);
  if (experience.length > 0) {
    labels.push(`${experience.join(', ')} experience`);
  }

  const types = (filter.hiringCapacities || []).filter((h) => h.isChecked);
  if (types.length === 1 && types[0].type === 'personal') {
    // Jobs from other sites are all from companies, so this hides them.
    labels.push('Personal only (hides jobs from other sites)');
  } else if (types.length === 1) {
    labels.push(`${types[0].label} only`);
  }

  if (filter.internal) {
    labels.push('Easy apply only');
  }

  if (filter.status === false) {
    labels.push('Including closed jobs');
  }

  return labels;
}
